module.exports = __webpack_public_path__ + "img/illustration-easy-to-implement.e42df797.svg";